import styled from "@emotion/styled";
import ReactHtmlParser from "@mediaspace/shared/ui/html-react-parser";
import { Typography } from "@kaltura/ds-react-components";
import {translate} from "@mediaspace/shared/utils";
import {HtmlReactParserOmitParagraphs, Truncate} from "@mediaspace/shared/ui";
import { generalHtmlStyles } from "@mediaspace/shared/ui/GeneralHtmlStyles";
import {ButtonClickAnalyticsType} from "@mediaspace/shared/types/ButtonClickAnalyticsType";
import {useButtonAnalytics} from "@mediaspace/hooks";

export interface DescriptionProps {
    description: string;
}

const showMoreClassName = "kms-ds-media-page-description-show-more";

const StyledDescription = styled(Typography)(({ theme }) => ([
    generalHtmlStyles(theme),
    {
        marginTop: theme.spacing(3),
        maxWidth: 789,
        [`& .${showMoreClassName}`]: {
            textTransform: "capitalize",
            textDecoration: "none",
            fontWeight: "bold",
        },
    }
]));

/**
 * media page metadata description
 */
export function Description(props: DescriptionProps) {
    const { description } = { ...props };

    const sendButtonAnalytics = useButtonAnalytics();

    const sendAnalytics = (isExpanded: boolean) => {
        const buttonType = isExpanded ? ButtonClickAnalyticsType.COLLAPSE : ButtonClickAnalyticsType.EXPAND;
        sendButtonAnalytics(`Media More info - ${isExpanded ? "Collapse" : "Expand"}`, buttonType);
    }

    return (
        <StyledDescription variant="body2" component="div" className="kms-ds-media-page-metadata-description">
                <Truncate
                    lines={3}
                    showMore={true}
                    showMoreInNewLine={true}
                    showMoreTranslatedText={translate("more info")}
                    showLessTranslatedText={translate("less info")}
                    toggleMoreClassName={showMoreClassName}
                    onToggle={(isExpanded) => {
                        sendAnalytics(isExpanded);
                    }}
                    originalText={ReactHtmlParser(description)}
                >
                    {HtmlReactParserOmitParagraphs(description)}
                </Truncate>
        </StyledDescription>
    );
}

export default Description;
